import * as React from "react";
import {FaUserAlt} from "@react-icons/all-files/fa/FaUserAlt";
import {HiMail} from "@react-icons/all-files/hi/HiMail";
import {Trans, useTranslation} from "react-i18next";
import {useI18next} from "gatsby-plugin-react-i18next";
import {graphql, useStaticQuery} from "gatsby";

/**
 * input names are from zoho and can not be changed!
 */
const ContactForm:React.FC = () => {
	const {defaultLanguage, language} = useI18next();
	const {t} = useTranslation();
	const {site} = useStaticQuery(
		graphql`
			query {
				site {
					siteMetadata {
						siteUrl
					}
				}
			}
		`
	);
	const baseUrl = defaultLanguage === language ?
		site.siteMetadata.siteUrl :
		`${site.siteMetadata.siteUrl}/${language}`;

	return (
		<div className="w-full bg-form">
			<div className="max-w-6xl mx-auto px-6 py-16">
				<h1 className="text-white text-xl pb-2 text-center uppercase font-semibold">
					<Trans>LEAVE US YOUR INFO</Trans>
				</h1>
				<p className="max-w-2xl mx-auto text-center font-normal text-sm text-white pb-8">
					<Trans>and we will get back to you.</Trans>
				</p>
				<form
					action='https://forms.zohopublic.eu/odania/form/Kontaktformular/formperma/0NtRA2W4OwqVn6uPdKpoYmqpMGeE1b2ne013b35Ab5s/htmlRecords/submit'
					name='form'
					id='form'
					method='POST'
					acceptCharset='UTF-8'
					encType='multipart/form-data'
				>
					<input type="hidden" name="zf_referrer_name" value=""/>
					<input
						type="hidden"
						name="zf_redirect_url"
						value={`${baseUrl}/contact-us-success`}
					/>
					<input type="hidden" name="zc_gad" value=""/>
					<div className="max-w-xl mx-auto">
						<div className="relative text-gray-400 focus-within:text-gray-400">
							<input
								className="appearance-none block w-full bg-white placeholder-text-greygoti border-2 mb-4 rounded-md py-5 px-7 leading-tight focus:outline-none focus:bg-white focus:border-blueish"
								id="grid-last-name"
								type="text"
								name="SingleLine"
								placeholder={t("Your Name")}
							/>
							<span className="absolute inset-y-0 right-0 flex items-center pr-2">
              <button
								className="p-1 focus:outline-none focus:shadow-outline"
							>
                <FaUserAlt/>
              </button>
            </span>
						</div>
						<div className="relative text-gray-400 ">
							<input
								className="appearance-none block w-full bg-white placeholder-text-greygoti border-2 mb-4 rounded-md py-5 px-7 leading-tight focus:outline-none focus:bg-white focus:border-blueish"
								id="grid-last-name"
								type="text"
								name="SingleLine1"
								placeholder={t("Email")}
							/>
							<span className="absolute inset-y-0 right-0 flex items-center pr-2">
              <button
								className="p-1 focus:outline-none focus:shadow-outline"
							>
                <HiMail/>
              </button>
            </span>
						</div>

						<input
							className="appearance-none block w-full bg-white placeholder-text-greygoti border-2 mb-4 rounded-md py-5 px-7 leading-tight focus:outline-none focus:bg-white focus:border-blueish"
							id="grid-subject"
							type="text"
							name="SingleLine2"
							placeholder={t("Subject")}
						/>
						<textarea
							className="appearance-none block w-full bg-white placeholder-text-greygoti border-2 mb-4 rounded-md py-5 px-7 leading-tight focus:outline-none focus:bg-white focus:border-blueish"
							id="grid-last-name"
							placeholder={t("Message")}
							rows={4}
							name="MultiLine"
						/>
						<button
							type="submit"
							className="w-full flex justify-center cursor-pointer rounded-md text-white text-center bg-blueish font-semibold py-4">
							<Trans>Submit Now</Trans>
						</button>
					</div>
				</form>
			</div>
		</div>
	);
};

export default ContactForm;
